const smplTheme={
  "colors": ["#d35400", "#2980b9", "#2ecc71", "#f1c40f", "#2c3e50", "#7f8c8d"],
  "yAxis": {
    "gridLineColor": "#E6E6E6",
    "lineColor": "#E6E6E6",
    "minorGridLineColor": "#E6E6E6",
    "tickColor": "#E6E6E6",
    "tickWidth": 1
  },
};

export default smplTheme;



// WEBPACK FOOTER //
// ./src/components/charts/highcharts-themes/smpl.js